import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\">\n<g id=\"icon-add_add\">\n<path id=\"icon-add_Union\" d=\"M11.025 12.975V18.75H12.975V12.975H18.75V11.025H12.975V5.25H11.025V11.025H5.25V12.975H11.025Z\" fill=\"#4AAB3D\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol